import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getStoreCreditHistory(params) {
    const { baseUrl, brandId, country, uberToken, clientId } = params;

    invariant(baseUrl, 'baseUrl is a required param of getDetailsById()');
    invariant(brandId, 'brandId is a required param of getDetailsById()');
    invariant(country, 'country is a required param of getDetailsById()');
    invariant(clientId, 'clientId is a required param of getDetailsById()');

    const localisedBrand = `${brandId}_${country.toLowerCase()}`;

    const url = `${baseUrl}wcs/resources/store/${localisedBrand}/credits/history`;

    return labelRequest(authenticatedRequest(new Request(url, { method: 'POST' }), uberToken, clientId), 'getStoreCreditHistory');
}
